import { DictionaryObject, useFetch } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function useGeneralSubmissionStates() {
  return useFetch<DictionaryObject[]>(
    `${EvidenceApiUrl.GENERAL_SUBMISSION}/states/list`,
    {
      method: 'GET',
      cacheResponse: true,
    }
  );
}

export function useGeneralSubmissionTypes() {
  return useFetch<DictionaryObject[]>(
    `${EvidenceApiUrl.GENERAL_SUBMISSION}/types/list`,
    {
      method: 'GET',
      cacheResponse: true,
    }
  );
}

export function useGeneralSubmissionAgendas() {
  return useFetch<DictionaryObject[]>(
    `${EvidenceApiUrl.GENERAL_SUBMISSION}/agendas/list`,
    {
      method: 'GET',
      cacheResponse: true,
    }
  );
}
